import { Outlet } from 'react-router'
import Header from '../../../component/layout/header'
import useNav from '../../../component/custom-hooks/get-nav';

const SummaryPlatformLayout = () => {

  const navList = useNav();
  let {MainSummaryTopNav, PlatformSummaryBottomNav} = navList;

  return (
    <div className="webBody">
      <Header bottomTabs={PlatformSummaryBottomNav} topTabs={MainSummaryTopNav} />
      <Outlet />
    </div>
  )
}

export default SummaryPlatformLayout